<template>
  <div
    class="app-store-links"
    :class="{ 'is-narrow': isNarrow }"
  >
    <h3
      v-if="showTitle"
      class="download-title"
    >
      {{ title }}
    </h3>
    <div class="store-badges">
      <!-- App Store Link -->
      <a
        :href="appStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="store-link"
        @click="() => $emit('store-click','ios')"
      >
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="Download on the App Store"
          class="store-badge"
        >
      </a>

      <!-- Google Play Store Link -->
      <a
        :href="playStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="store-link"
        @click="() => $emit('store-click','android')"
      >
        <img
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
          alt="Get it on Google Play"
          class="store-badge"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppStoreLinks',
  props: {
    title: {
      type: String,
      default: 'Download Our Mobile App',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    isNarrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    appStoreUrl() {
      return process.env.VUE_APP_APP_STORE_URL;
    },
    playStoreUrl() {
      return process.env.VUE_APP_PLAY_STORE_URL;
    },
  },
};
</script>

<style scoped lang="scss">
.app-store-links {
  text-align: center;
  padding: 20px;
  max-width: 500px;
  margin: 0 auto;
}

.download-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 20px;
  /* color: #333; */ // light mode
  color: #f0f0f0;
}

.store-badges {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.store-link {
  display: inline-block;
  transition: transform 0.2s ease, opacity 0.2s ease;
  text-decoration: none;
}

.store-link:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.store-link:active {
  transform: translateY(0);
}

.store-badge {
  height: 55px;
  width: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
  filter: brightness(0.9);
}

/* Normalize badge sizes - Google Play badge has built-in padding */
.store-link:nth-child(2) .store-badge {
  /* Google Play badge - make it slightly larger to compensate for internal padding */
  height: 92px;
  transform: scale(0.85);
}

/* Add some margin to the AppStore logo so they appear in the centre */
.store-link:first-child .store-badge {
  margin-left: 20px;
}

.store-badge:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.is-narrow {
  .store-badges {
    flex-direction: column;
    align-items: center;
  }

  .store-badge {
    height: 50px;
    width: auto;
  }

  .store-link:first-child .store-badge {
    margin-left: 0px;
  }

  .store-link:nth-child(2) .store-badge {
    height: 80px;
    transform: scale(0.85);
  }
}

/* Responsive design */
@media (max-width: 560px) {
  .store-badges {
    flex-direction: column;
    gap: 10px;
  }

  .store-badge {
    height: 50px;
  }

  .store-link:first-child .store-badge {
    margin-left: 0px;
  }

  /* Adjust Google Play badge for mobile */
  .store-link:nth-child(2) .store-badge {
    height: 80px;
    transform: scale(0.85);
  }

  .download-title {
    font-size: 1.25rem;
  }

  .app-store-links {
    padding: 15px;
  }
}

@media (max-width: 320px) {
  .store-badge {
    height: 45px;
  }

  /* Adjust Google Play badge for small screens */
  .store-link:nth-child(2) .store-badge {
    height: 74px;
    transform: scale(0.85);
  }
}

// /* Dark mode support */
// @media (prefers-color-scheme: dark) {
//   .download-title {
//     color: #f0f0f0;
//   }

//   .store-badge {
//     filter: brightness(0.9);
//   }
// }
</style>
